import React, { useState } from 'react';
import { Form, FormItem, Input, Button, Card, useToast } from '../ui';
import { UserIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';

interface LoginForm {
  email: string;
  password: string;
}

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const { success: toastSuccess, error: toastError } = useToast();

  const onFinish = async (values: LoginForm) => {
    try {
      setLoading(true);
      await signIn(values.email, values.password);
      toastSuccess('Login successful!');
    } catch (error: any) {
      toastError(error.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-500 via-purple-500 to-purple-700">
      <Card 
        className="w-full max-w-md shadow-2xl"
        padding="lg"
      >
        <div className="text-center mb-6">
          <div className="flex justify-center mb-4">
            <img 
              src="/logo.png" 
              alt="Dress Shop Logo" 
              className="h-48 w-auto"
            />
          </div>
          <p className="text-gray-600">Sign in to your admin dashboard</p>
        </div>

        <Form onSubmit={onFinish}>
          <FormItem
            name="email"
            label="Email"
            required
          >
            <Input
              type="email"
              placeholder="Enter your email"
              leftIcon={<UserIcon className="h-5 w-5" />}
              size="lg"
              required
            />
          </FormItem>

          <FormItem
            name="password"
            label="Password"
            required
          >
            <Input
              type="password"
              placeholder="Enter your password"
              leftIcon={<LockClosedIcon className="h-5 w-5" />}
              size="lg"
              required
            />
          </FormItem>

          <div className="mt-6">
            <Button 
              type="submit"
              variant="primary"
              size="lg"
              loading={loading}
              className="w-full"
            >
              Sign In
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Login; 